"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MediaQueryNotFoundException extends Error {
    constructor(name) {
        super(`La media query '${name}' non è stata trovata.`);
    }
}
exports.MediaQueryNotFoundException = MediaQueryNotFoundException;
//# sourceMappingURL=MediaQueryExceptions.js.map